// Copyright 2022 Northern.tech AS
//
//    Licensed under the Apache License, Version 2.0 (the "License");
//    you may not use this file except in compliance with the License.
//    You may obtain a copy of the License at
//
//        http://www.apache.org/licenses/LICENSE-2.0
//
//    Unless required by applicable law or agreed to in writing, software
//    distributed under the License is distributed on an "AS IS" BASIS,
//    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//    See the License for the specific language governing permissions and
//    limitations under the License.
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  default: { color: theme.palette.text.disabled, margin: '15px 0' }
}));

export const InfoText = ({ children, className = '', variant = '', ...props }) => {
  const { classes } = useStyles();
  const Component = variant === 'dense' ? 'span' : 'p';
  return (
    <Component className={`${classes.default} ${className}`} {...props}>
      {children}
    </Component>
  );
};
export default InfoText;
